<app-playground
    [backgrounds]="[
        'https://www.poettinger.at/img/myPoettinger/MeinMaschinenpark/AEROSEM_5002_FDD_Tank_Beladesteg_DSC9537_20200713_SAT_2000x1000px.webp',
        'https://www.poettinger.at/img/myPoettinger/MeinMaschinenpark/NOVADISC812_Fendt_9-1_2000x1000px.webp',
        'https://www.poettinger.at/img/myPoettinger/MeinMaschinenpark/TERRIA_6040_Case_Leipzig-5324_2000x1000px.webp',
        'https://www.poettinger.at/img/myPoettinger/MeinMaschinenpark/TOP1403C_JohnDeere25-1_2000x1000px.webp',
    ]"
    title="{{ 'MyMachine' | translate }}"
>
    <div class="container mt-5 mb-5">
        @if (!isLoggedIn()) {
            <h3>{{ "ihrMPark" | translate }}</h3>
        }
        <p class="mt-2 mb-5">
            {{ "MyMachineHText" | translate }}
        </p>
    </div>
</app-playground>

<div class="container pt-5">
    @if (this.userMachinesResource.isLoading()) {
        <app-progress-spinner></app-progress-spinner>
    } @else {
        <h3>{{ "machines" | translate }}</h3>
        <ul
            cdkDropList
            class="drag-drop-list machine-list"
            (cdkDropListDropped)="dropMachine($event)"
        >
            @for (
                machine of userMachinesResource.value();
                track machine.machineNumber
            ) {
                <li
                    class="drag-drop-item poe-row machine-row"
                    (click)="onClickMachine(machine)"
                    (keypress)="onClickMachine(machine)"
                    cdkDrag
                >
                    <img
                        [alt]="machine.phkey"
                        src="//www.poettinger.at/img/icons_svg/300/{{
                            machine.phkey
                        }}.svg"
                        class="image"
                    />
                    <span class="main-text">{{ machine.userDefinedName }}</span>
                    <span class="secondary-text"
                        >Chassis-Nr.: {{ machine.machineNumber }}</span
                    >
                    @if (
                        machine.connectedTelemetryUnitId ||
                        machine.suggestedTelemetryUnitId
                    ) {
                        <app-telemetry-status-circle
                            [status]="
                                machine.connectedTelemetryUnitId
                                    ? 'online'
                                    : 'warning'
                            "
                            class="telemetry-unit"
                        >
                        </app-telemetry-status-circle>
                    } @else {
                        <div
                            style="aspect-ratio: 1 / 1"
                            class="telemetry-unit"
                        ></div>
                        <!-- Placeholder for alignment -->
                    }
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        class="hint"
                    >
                        <path
                            d="M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"
                        />
                    </svg>
                </li>
            }
            <li
                class="machine-row poe-row add-row"
                (click)="onClickAddMachine()"
                (keypress)="onClickAddMachine()"
            >
                <span class="main-text">{{ "addMachine" | translate }}</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                    class="hint"
                >
                    <path
                        d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z"
                    />
                </svg>
            </li>
            <div
                class="pointer p-0"
                [hidden]="!showMachineAdd"
                #ebeneMachineAdd
            >
                <app-machinesearch
                    [embedded]="true"
                    [machineAdd]="true"
                ></app-machinesearch>
            </div>
        </ul>
    }
</div>
